import { render, staticRenderFns } from "./MomentosContablesView.vue?vue&type=template&id=6ded2fa6&"
import script from "./MomentosContablesView.vue?vue&type=script&lang=js&"
export * from "./MomentosContablesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports